module.exports = __webpack_public_path__ + "img/03.57e700a9.png";